import {
  BoxProps,
  Stack
} from '@mui/material';
import React, {
  ReactElement,
  ReactNode
} from 'react';



export type StyledActivityCardBackgroundProps = {
  children: ReactNode | ReactNode[] | ReactElement;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: StyledActivityCardBackgroundProps & BoxProps) => {

  return (
    <Stack
      sx={{
        background: 'linear-gradient(0deg, rgba(2, 0, 67, 0.00) 72.6%, rgba(2, 0, 67, 0.02) 99.87%), var(--Supporting-white, #FFF)'
      }}
      justifyContent='stretch'
      alignItems='stretch'
      borderRadius='1.5rem'
      border='6px solid white'
      direction='column'
      paddingX='2rem'
      paddingY='2rem'
      rowGap='1.5rem'
    >
      {props.children}

    </Stack>
  );
};
